import { createTheme } from "@mui/material";


export const theme = createTheme({
    typography: {
        fontFamily: 'Inter, sans-serif',
        color: '#000'
    },
})